<template>
  <div class="live-cities-main"  v-if="showLayout">
  <div class="live-cities-inner">
    <h4><i class="fas fa-city"></i> Live Cities</h4>
    <div class="footer-city-list">
      <div class="tr-inner-list" v-for="(city, index) in all_data" :key="index">
      <a @click="subClick(city.name, area.name, area.id)"
         v-for="(area, index_) in city.sub_areas" :key="index_">
        {{area.name}}
      </a>
    </div>
    <!--<ul class="tr-inner-list" v-for="(city, index) in Object.keys(cities)" :key="index">
      <a @click="subClick(cities[city], area, index_)"
         v-if="areas[city].values" v-for="(area, index_) in areas[city].values" :key="index_">
        <li> {{area}}</li>
      </a>
    </ul>-->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    area_id: {
      type: String,
      default: '0'
    }
  },
  name: 'LiveCityListFooter',
  data () {
    return {
      areas: {},
      cities: null,
      showLayout: false,
      all_data: null
    }
  },
  watch: {
    areas: {
      deep: true,
      handler () {}
    }
  },
  mounted () {
    //this.getAreaList(0)
    this.getAreaListAll(0)
  },
  methods: {
    getAreaListAll (parent) {
      this.$vs.loading()
      const payload = {
        parent
      }
      this.$store.dispatch('api/getAreaListAll', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.all_data = response.data.data
          this.showLayout = true
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getAreaList (parent) {
      this.$vs.loading()
      const payload = {
        parent
      }
      this.$store.dispatch('api/getAreaList', payload)
        .then((response) => {
          this.$vs.loading.close()
          if (parent === 0) {
            this.cities = response.data.data
            this.areas = {}
            Object.keys(this.cities).map(city_id => {
              this.getAreaList(city_id)
            })
          } else {
            const areas = {
              city_id: parent,
              values: response.data.data
            }
            this.areas[parent] = areas


            if (Object.keys(this.areas).length === Object.keys(this.cities).length) {
              if (this.area_id !== '0') {
                let city_id = ''
                Object.keys(this.areas).map(area_var => {
                  const arr = Object.keys(this.areas[area_var].values).includes(this.area_id)

                  if (arr) {
                    city_id = this.areas[area_var].city_id
                  }
                })
                const city = this.cities[city_id]
                const area = this.areas[city_id].values[this.area_id]
                this.subClick(city, area, this.area_id)

              }
              this.showLayout = true
            }
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    subClick (city, url, id) {
      this.setSelectedCity(city)

      this.$router.push({
        name: 'live-cities',
        params: {
          area: url.toLowerCase().replace(' ', '-'),
          city: city.toLowerCase().replace(' ', '-'),
          area_id: id.toString()
        }})
    },
    setSelectedCity (text) {
      this.$store.dispatch('api/setSelectedCity', text)
    }
  }
}
</script>

<style lang="scss">
.live-cities-main {
  width:100%;
  background-color:#111111;
  padding:20px;
  display:flex;
  justify-content:center;
}
.live-cities-inner{
  width:1035px;
  max-width:1035px;
  h4{
    color:#fff;
    width:max-content;
    border-bottom:1px solid #fff;
    margin-bottom:20px;
  }
}
.footer-city-list {
  .tr-inner-list{
    a{
      margin-right:15px;
      cursor:pointer;
      position:relative;
      display:block;
      color:#c4c4c4;
      font-weight: 700;
      &:hover{
        color:#fff;
        text-decoration: underline;
      }
    }
    display: flex;
    flex-direction: column;
    flex: 1 1 0%;
  }
  display:flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
